import { View } from 'react-native'
import type { StampSettings } from './useStampSettings'
import { PerMealSection } from './PerMealSection'
import { SpendBasedInput } from './SpendBasedInput'

interface StampCollectionSectionProps {
  settings: StampSettings
  currentStamps?: number
  mealsCount: number
  onMealsCountChange: (v: number) => void
  purchaseAmount: string
  onPurchaseAmountChange: (v: string) => void
  receiptReference: string
  onReceiptReferenceChange: (v: string) => void
  onAddStamps: () => void
}

export function StampCollectionSection({
  settings,
  currentStamps,
  mealsCount,
  onMealsCountChange,
  purchaseAmount,
  onPurchaseAmountChange,
  receiptReference,
  onReceiptReferenceChange,
  onAddStamps,
}: StampCollectionSectionProps) {
  const { earningRule, maxStampsPerTransaction, stampTarget, receiptReferenceEnabled, completionCardIcon, milestones } = settings

  return (
    <View className="gap-4">
      {earningRule.method === 'per_meal' ? (
        <PerMealSection
          mealsCount={mealsCount}
          onMealsCountChange={onMealsCountChange}
          maxStampsPerTransaction={maxStampsPerTransaction}
          currentStamps={currentStamps}
          stampTarget={stampTarget}
          completionCardIcon={completionCardIcon}
          milestones={milestones}
          receiptReferenceEnabled={receiptReferenceEnabled}
          receiptReference={receiptReference}
          onReceiptReferenceChange={onReceiptReferenceChange}
          onAddStamps={onAddStamps}
        />
      ) : (
        <SpendBasedInput
          amount={purchaseAmount}
          amountPerStamp={earningRule.amountPerStamp}
          onAmountChange={onPurchaseAmountChange}
          currentStamps={currentStamps}
          stampTarget={stampTarget}
          maxStampsPerTransaction={maxStampsPerTransaction}
          completionCardIcon={completionCardIcon}
          milestones={milestones}
          receiptReferenceEnabled={receiptReferenceEnabled}
          receiptReference={receiptReference}
          onReceiptReferenceChange={onReceiptReferenceChange}
          onAddStamps={onAddStamps}
        />
      )}

      <View className="h-px bg-border" />
    </View>
  )
}